/**
 * Canadian dollar.
 */
export var CAD = {
  code: 'CAD',
  base: 10,
  exponent: 2
};